import { useMutation, useQueryClient } from '@tanstack/react-query';
import { flowsApi } from '@/services/flows.api';

export function useFlowMutations() {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: { name: string; description?: string }) => flowsApi.createFlow(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flows'] });
    },
    onError: (error: any) => {
      console.error('Failed to create flow:', error);
      throw error;
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: { name?: string; description?: string } }) =>
      flowsApi.updateFlow(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flows'] });
    },
    onError: (error: any) => {
      console.error('Failed to update flow:', error);
      throw error;
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => flowsApi.deleteFlow(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flows'] });
    },
    onError: (error: any) => {
      console.error('Failed to delete flow:', error);
      throw error;
    },
  });

  return { createMutation, updateMutation, deleteMutation };
}
